import React from 'react';
import { u as useInView_2 } from './useInView-CMTI-J0M.js';
import classnames from 'classnames';

const CONTAINER_TEST_ID = "ATL-DataListFilters-Container";

var styles = {"fadeContainer":"jbBRoxlZlNI-","overflowItems":"P6uJ-vHfKrM-","overflowGrid":"MnN8qbS4hw4-","overflowTrigger":"b-5P7Z8eGO8-","overflowLeft":"xzaCS4slLpI-","overflowRight":"Jf227kC8Nu0-"};

function DataListOverflowFade({ children }) {
    const [leftRef, isLeftVisible] = useInView_2();
    const [rightRef, isRightVisible] = useInView_2();
    return (React.createElement("div", { "data-testid": CONTAINER_TEST_ID, className: classnames(styles.fadeContainer, {
            [styles.overflowLeft]: !isLeftVisible,
            [styles.overflowRight]: !isRightVisible,
        }) },
        React.createElement("div", { className: styles.overflowGrid },
            React.createElement("span", { ref: leftRef, className: styles.overflowTrigger }),
            React.createElement("div", { className: styles.overflowItems }, children),
            React.createElement("span", { ref: rightRef, className: styles.overflowTrigger }))));
}

export { CONTAINER_TEST_ID as C, DataListOverflowFade as D };
